/**
 * Hand-over between the public login pages without putting the mail into the URL:
 * - prefill mail: login ↔ "Passwort vergessen" ↔ "Fertig" (this tab only, read once)
 * - completed purpose: "Passwort festlegen" → "Fertig" (invitation or reset)
 * - remembered mail: "E-Mail merken" on the login (this browser, until unticked)
 * Storage is optional everywhere: without it the pages simply start empty.
 */
export type CompletedPurpose = 'invite' | 'reset';

const PREFILL_KEY = 'vanilla.login.prefillMail';
const COMPLETED_KEY = 'vanilla.login.completed';
const REMEMBER_KEY = 'vanilla.login.rememberedMail';

function get(storage: () => Storage, key: string): string | null {
    try {
        return storage().getItem(key);
    } catch (e) {
        return null;
    }
}

function set(storage: () => Storage, key: string, value: string | null) {
    try {
        if (value === null || value === '') {
            storage().removeItem(key);
        } else {
            storage().setItem(key, value);
        }
    } catch (e) {
        // storage is optional
    }
}

const session = () => sessionStorage;
const local = () => localStorage;

export function setPrefillMail(mail: string | null | undefined) {
    set(session, PREFILL_KEY, (mail || '').trim() || null);
}

/** Whether the login will be prefilled (without consuming it) */
export function hasPrefillMail(): boolean {
    return !!get(session, PREFILL_KEY);
}

export function takePrefillMail(): string {
    const mail = get(session, PREFILL_KEY) || '';
    set(session, PREFILL_KEY, null);
    return mail;
}

export function setCompleted(purpose: CompletedPurpose) {
    set(session, COMPLETED_KEY, purpose);
}

export function takeCompleted(): CompletedPurpose | null {
    const value = get(session, COMPLETED_KEY);
    set(session, COMPLETED_KEY, null);
    return value === 'invite' || value === 'reset' ? value : null;
}

export function getRememberedMail(): string {
    return get(local, REMEMBER_KEY) || '';
}

/** Remembers the mail (or forgets it when the box is unticked) */
export function rememberMail(mail: string | null) {
    set(local, REMEMBER_KEY, mail ? mail.trim() : null);
}
